<template>
    <div>
        <router-view name="header"></router-view>

        <router-view class="min-vh-100"></router-view>
        
        <router-view name="footer"></router-view>
    </div>
</template>

<script>

export default {
    name: "AdminMaster",
    data () {
        return {}
    },
    methods: {},
    props: {},
    created () {},
    computed: {},
    watch: {},
}
</script>

<style scoped>


</style>
